import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  forwardRef,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { createTextMaskInputElement } from 'text-mask-core';

interface TextMaskConfig {
  mask: unknown[];
  guide: boolean;
  placeholderChar: string;
  pipe?: unknown;
  keepCharPositions: boolean;
}

@Directive({
  selector: '[textMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextMaskDirective),
      multi: true,
    },
  ],
})
export class TextMaskDirective implements OnInit, ControlValueAccessor {
  @Input('textMask') textMaskConfig: TextMaskConfig = {
    mask: [],
    guide: true,
    placeholderChar: '_',
    pipe: undefined,
    keepCharPositions: false,
  };

  private textMaskInputElement: unknown;
  private inputElement: HTMLInputElement;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private _onTouched = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private _onChange = (_value: unknown): void => {};

  private elementRef = inject(ElementRef);

  constructor() {
    this.inputElement = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.textMaskInputElement = createTextMaskInputElement({
      inputElement: this.inputElement,
      ...this.textMaskConfig,
    }) as { update: (value?: string) => void };
    (this.textMaskInputElement as { update: (value?: string) => void }).update(
      this.inputElement.value,
    );
  }

  writeValue(value: string): void {
    if (this.textMaskInputElement && value) {
      (this.textMaskInputElement as { update: (value?: string) => void }).update(value);
    }
  }

  registerOnChange(fn: (value: unknown) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  @Input() set textMask(value: TextMaskConfig) {
    this.textMaskConfig = value;
    if (this.textMaskInputElement) {
      this.textMaskInputElement = createTextMaskInputElement({
        inputElement: this.inputElement,
        ...this.textMaskConfig,
      }) as { update: (value?: string) => void };
      (this.textMaskInputElement as { update: (value?: string) => void }).update(
        this.inputElement.value,
      );
    }
  }

  @HostListener('input', ['$event'])
  onInput(_event: Event) {
    if (this.textMaskInputElement) {
      (this.textMaskInputElement as { update: (value?: string) => void }).update();
      this._onChange(this.inputElement.value);
    }
  }

  @HostListener('blur')
  onBlur() {
    this._onTouched();
  }
}
